import securityStyles from "../styles/passkey-security.module.css";

const PasskeyRecoveryCodes = ({ codes = [] }) => {
    if (!codes?.length) {
        return null;
    }

    return (
        <div className={securityStyles.recoveryWrap}>
            <h5 className={securityStyles.recoveryTitle}>Save your recovery codes now</h5>
            <p className={securityStyles.recoveryCopy}>
                Each code can be used once if you lose access to your passkeys. Store them somewhere secure outside this app.
            </p>
            <div className={securityStyles.codeGrid}>
                {codes.map((code) => (
                    <div key={code} className={securityStyles.codeChip}>
                        {code}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PasskeyRecoveryCodes;
